module.exports = __webpack_public_path__ + "static/img/login-bg-teacher.a15395a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login/login-bg-teacher.jpg
// module id = c4bt
// module chunks = 1